module.exports = __webpack_public_path__ + "assets/b106.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b106.png
// module id = 577
// module chunks = 0